<template>
  <div class="redirect-to-discount-popup" :class="{ loading }">
    <popup title="רגע לפני שנעבור לאתר דיסקונט"
           :close-action="closeModal"
           :buttons="buttons">
      <template v-slot:content>
        <div class="content">
          <span>מיד נעביר אותך מאתר riseup לאתר בנק דיסקונט. תמיד אפשר לחזור להמשך הגדרת החשבונות </span>
            <span class="bold"> דרך הלינק שנשלח אליך ב- WhatApp.</span>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BaseUI from 'base-ui';
import DiscountApi from '../../../../api/DiscountApi';
import Segment from '../../../../Segment';

export default {
  name: 'RedirectToDiscountPopup',
  props: [
    'source',
    'idNumber',
  ],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    Segment.trackUserGot('RedirectToDiscountPopupShown');
  },
  components: {
    RiseupButton: BaseUI.RiseupButton,
    Popup: BaseUI.Popup,
  },
  computed: {
    buttons() {
      return [
        {
          title: 'קחו אותי לאתר דיסקונט',
          variant: 'discount',
          action: this.redirectToGetAccessCode,
          loading: this.loading,
        },
        {
          title: 'אתחבר בפעם אחרת',
          variant: 'discount-secondary',
          action: this.closeModal,
        },
      ];
    },
  },
  methods: {
    ...mapActions('credentials', ['updatePendingCredentials']),
    closeModal() {
      Segment.trackUserInteraction('RedirectToDiscountPopup_CloseClicked', { idNumber: this.idNumber });
      this.$emit('close');
    },
    async redirectToGetAccessCode() {
      this.loading = true;
      Segment.trackUserInteraction('RedirectToDiscountPopup_ContinueInDiscountClicked', { idNumber: this.idNumber });
      await this.updatePendingCredentials({ source: this.source });
      const redirectUrl = await DiscountApi.getAccessCodeUrl(this.idNumber, this.source.credentialsId);
      window.location.href = redirectUrl;
    },
  },
};
</script>

<style lang="scss" scoped>

  .redirect-to-discount-popup {
    &.loading{
      opacity: 0.5;
      pointer-events: none;
    }

    .content {
      line-height: 20px;

      .bold {
        font-weight: bold;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/non-authenticated/discount-api/RedirectToDiscountPopup.vue